/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Usage_TitleInputs */

const en_cookies_usage_title = /** @type {(inputs: Cookies_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we use cookies`)
};

const pl_cookies_usage_title = /** @type {(inputs: Cookies_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak używamy plików cookie`)
};

/**
* | output |
* | --- |
* | "How we use cookies" |
*
* @param {Cookies_Usage_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_usage_title = /** @type {((inputs?: Cookies_Usage_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Usage_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_usage_title(inputs)
	return en_cookies_usage_title(inputs)
});